<template lang="html">
  <button>{{ title }}</button>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style lang="css" scoped>

button {
    margin: 0;
    padding: 20px;
    font-size: 1.2em;
    letter-spacing: 0.2em;
    font-variant: small-caps;
    
    color: var(--primaryColor);
    background-color: var(--highlightColor);
    border: none;
    border-radius: 20px;
    width: 100%;
    box-shadow: 0 2px 2px rgba(0,0,0,0.2);
}

</style>
